import { render } from "./GRBG.vue?vue&type=template&id=9b0716a2&scoped=true"
import script from "./GRBG.vue?vue&type=script&lang=js"
export * from "./GRBG.vue?vue&type=script&lang=js"

import "./GRBG.vue?vue&type=style&index=0&id=9b0716a2&scoped=scoped&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b0716a2"]])

export default __exports__